// Pre-launch gate. While false, the "Get Started" flow shows an "almost launching"
// screen instead of the registration/checkout form, so no one can create an account
// or pay before we're 100% ready.
//
// TO OPEN REGISTRATION AT LAUNCH: set REGISTRATION_OPEN = true (single line) and redeploy.
//
// Team bypass for testing the real flow while gated: visit /get-started?preview=1 once
// (it sets a localStorage flag), or append ?preview=1 to the URL.
export const REGISTRATION_OPEN = false;

const BYPASS_KEY = 'sivo_registration_preview';

// True when the real registration form should be shown: either registration is open,
// or this browser has the team-preview bypass enabled.
export function isRegistrationOpen() {
  if (REGISTRATION_OPEN) return true;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('preview') === '1') {
      localStorage.setItem(BYPASS_KEY, '1');
      return true;
    }
    return localStorage.getItem(BYPASS_KEY) === '1';
  } catch (_) {
    return false;
  }
}
